import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'EDIT_BILL_PAYER_SPLIT_MODAL';
export const {action: show} = createAction(`${domain}/SHOW`, (institutionId, childId, splitConfiguration) => ({
    institutionId,
    childId,
    splitConfiguration,
}));

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {
    action: removeBillPayerFromSplit,
    success: removeBillPayerFromSplitSuccess,
    failed: removeBillPayerFromSplitFailed,
    aborted: removeBillPayerFromSplitAborted,
} = createAction(
    `${domain}/REMOVE_FROM_SPLIT`,
    (institutionId, childId, billPayerId, billPayerName, oldSplitConfiguration) => ({
        institutionId,
        childId,
        billPayerId,
        billPayerName,
        oldSplitConfiguration,
    }),
    newConfiguration => ({newConfiguration}),
);

export const {action: shareChanged} = createAction(
    `${domain}/SHARE_CHANGED`,
    (billPayerId, newShare, actualEditSplitConfiguration) => ({billPayerId, newShare, actualEditSplitConfiguration}),
);

export const {action: clearBillPayerEdit} = createAction(`${domain}/CLEAR_BILL_PAYER_EDIT`, billPayerId => ({
    billPayerId,
}));

export const {action: moveDown} = createAction(`${domain}/MOVE_DOWN`, (billPayerId, actualEditSplitConfiguration) => ({
    billPayerId,
    actualEditSplitConfiguration,
}));

export const {action: shareTypeChanged} = createAction(
    `${domain}/SHARE_TYPE_CHANGED`,
    (billPayerId, newType, actualEditSplitConfiguration) => ({billPayerId, newType, actualEditSplitConfiguration}),
);

export const {action: showExample} = createAction(`${domain}/SHOW_EXAMPLE`, show => ({show}));

export const {action: updateExampleTotal} = createAction(`${domain}/UPDATE_EXAMPLE_TOTAL`, newTotal => ({newTotal}));

export const {
    action: saveSplit,
    success: saveSplitSuccess,
    failed: saveSplitFailed,
} = createAction(
    `${domain}/SAVE_SPLIT`,
    (institutionId, childId, splitConfiguration) => ({
        institutionId,
        childId,
        splitConfiguration,
    }),
    splitConfiguration => ({splitConfiguration}),
);
